import * as iots from 'io-ts';

/**
 * Strict prefixes for word list searches.
 */
export const enum LatinPrefix {
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
  E = 'e',
  F = 'f',
  G = 'g',
  H = 'h',
  I = 'i',
  J = 'j',
  K = 'k',
  L = 'l',
  M = 'm',
  N = 'n',
  O = 'o',
  P = 'p',
  Q = 'q',
  R = 'r',
  S = 's',
  T = 't',
  U = 'u',
  V = 'v',
  W = 'w',
  X = 'x',
  Y = 'y',
  Z = 'z',
}

export const CanonicalLatinPrefixOrder: LatinPrefix[] = [
  LatinPrefix.A,
  LatinPrefix.B,
  LatinPrefix.C,
  LatinPrefix.D,
  LatinPrefix.E,
  LatinPrefix.F,
  LatinPrefix.G,
  LatinPrefix.H,
  LatinPrefix.I,
  LatinPrefix.J,
  LatinPrefix.K,
  LatinPrefix.L,
  LatinPrefix.M,
  LatinPrefix.N,
  LatinPrefix.O,
  LatinPrefix.P,
  LatinPrefix.Q,
  LatinPrefix.R,
  LatinPrefix.S,
  LatinPrefix.T,
  LatinPrefix.U,
  LatinPrefix.V,
  LatinPrefix.W,
  LatinPrefix.X,
  LatinPrefix.Y,
  LatinPrefix.Z,
];

const LatinPrefixCodec: iots.Type<LatinPrefix> = iots.keyof({
  [LatinPrefix.A]: null,
  [LatinPrefix.B]: null,
  [LatinPrefix.C]: null,
  [LatinPrefix.D]: null,
  [LatinPrefix.E]: null,
  [LatinPrefix.F]: null,
  [LatinPrefix.G]: null,
  [LatinPrefix.H]: null,
  [LatinPrefix.I]: null,
  [LatinPrefix.J]: null,
  [LatinPrefix.K]: null,
  [LatinPrefix.L]: null,
  [LatinPrefix.M]: null,
  [LatinPrefix.N]: null,
  [LatinPrefix.O]: null,
  [LatinPrefix.P]: null,
  [LatinPrefix.Q]: null,
  [LatinPrefix.R]: null,
  [LatinPrefix.S]: null,
  [LatinPrefix.T]: null,
  [LatinPrefix.U]: null,
  [LatinPrefix.V]: null,
  [LatinPrefix.W]: null,
  [LatinPrefix.X]: null,
  [LatinPrefix.Y]: null,
  [LatinPrefix.Z]: null,
});

export const isLatinPrefix = LatinPrefixCodec.is;
